import React from 'react';
import styled, { keyframes } from 'styled-components';

const donutAnimation = keyframes`
    0% {
        stroke-dasharray: 0, 100;
    }
    100% {
        stroke-dasharray: 100, 0;
    }
`;

const DonutContainer = styled.div`
    width: 32px;
    height: 32px;
    position: absolute;
    right: 10px;
    top: 12px;

    svg {
        width: 98%;
        height: 98%;
        left: 0;
        top: 0;
    }
`;

const DonutCircle = styled.circle`
    stroke: #072647;
    animation: ${donutAnimation} 1.5s forwards;
    stroke-width: 3.5px;
    stroke-dashoffset: 25;
`;

const Donut = () => (
    <DonutContainer>
        <svg width="100%" height="100%" viewBox="0 0 40 40">
            <DonutCircle cx="20" cy="20" r="15.91549430918954" fill="transparent" />
        </svg>
    </DonutContainer>
);

export default Donut;
